export default "__VITE_ASSET__Do$k07bN__"